<template>
  <div class="history-list l-container">
    <div class="list-content">
      <!-- Left-content -->
      <div class="list-content-left">
        <LeftMenuHistory />
      </div>

      <!-- Right-contents -->
      <div class="list-content-right">
        <!-- Title -->
        <div class="page-title">
          <h1>お申し込み履歴</h1>
        </div>

        <!-- Divider -->
        <div class="divider"></div>

        <!-- Tabs-card-container -->
        <div class="tabs-card-container">
          <!-- Filter -->
          <div class="tabs-card">
            <!-- Contents -->
            <a-card class="tabs-card-content">
              <a-tabs justify-content="space-evenly" default-active-key="1">
                <!-- Tab-left -->
                <a-tab-pane name="fav-list" key="1">
                  <template slot="tab">
                    <span class="lg:hidden">ベネフィット・ステーションのサービス</span>
                    <span class="hidden lg:block text-center">
                      ベネフィット・<br />ステーションのサービス
                    </span>
                  </template>
                  <div class="utilities">
                    <!-- Pagination -->
                    <div class="pagination">
                      <div class="text-count w-1/4 sm:w-1/2 flex items-center">
                        <strong>{{ totalResults }}</strong
                        >件中 1～10件表示
                      </div>
                      <Pagination
                        class="sm:w-full flex justify-center sm:hidden"
                        :page="page"
                        @onChange="getPanigationResults"
                        :totalRecord="totalResults"
                      />
                      <div class="filter-button-sm">
                        <a-button class="b-button">
                          <span class="icon icon-bor-filter"></span>
                          <span>カテゴリで絞り込む</span>
                        </a-button>
                      </div>
                    </div>
                  </div>
                </a-tab-pane>

                <!-- Tab-right -->
                <a-tab-pane name="tab-right" key="2">
                  <template slot="tab">
                    <span class="lg:hidden">外部サービス</span>
                    <span class="hidden lg:block text-left">
                      <br />
                      外部サービス
                    </span>
                  </template>
                </a-tab-pane>
              </a-tabs>
            </a-card>
          </div>
          <!-- Cards detail -->
          <div v-if="dataList.length">
            <ItemCards v-model="dataList" />
          </div>
          <div v-else>
            <a-card style="text-align: center">該当するお知らせはありません。</a-card>
          </div>
          <!-- Card pagination -->
          <div class="item-pagination">
            <a-card class="base-content-bottom">
              <div class="pagination">
                <div class="text-bottom w-1/4 sm:w-full flex items-center">
                  <strong>{{ totalResults }}</strong
                  >件中 1～10件表示
                </div>
                <Pagination
                  class="sm:w-full flex justify-center"
                  :page="page"
                  @onChange="getPanigationResults"
                  :totalRecord="totalResults"
                />
              </div>
            </a-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LeftMenuHistory } from '@/components/compound'
import ItemCards from './components/ItemCards'
import { GET_ORDER_LIST_HISTORY } from '@/store/modules/bs_myp/actions'
import { Pagination } from '@/components/primitive'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import _ from 'lodash'

export default {
  name: 'BS_MYP_05_001',
  components: {
    ItemCards,
    Pagination,
    LeftMenuHistory
  },
  data() {
    return {
      page: 1,
      dataList: [],
      dataSearch: null,
      placeHolder: '',
      textSearch: '',
      categoryValue: 0,
      totalResults: 0,
      acptDtlNo: null
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.getOrderListHistory()
      const mybreadcrumbs = {
        path: '/mypage/orders',
        title: 'お申し込み履歴'
      }
      this.breadcrumbs.push(mybreadcrumbs)
      this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({ path: '/', query: params })
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
  },
  methods: {
    getOrderListHistory() {
      const params = {
        menuNm: this.textSearch,
        startIndex: 0,
        reserveSts: this.categoryValue
      }
      this.$store.dispatch(GET_ORDER_LIST_HISTORY, params).then((data) => {
        this.dataList = data.orderInfoList
        this.totalResults = this.dataList.length
        this.getPanigationResults(1)
      })
    },
    getPanigationResults(val) {
      this.page = val
      const params = {
        menuNm: this.textSearch,
        startIndex: val < 1 ? 0 : (val - 1) * 10,
        count: 10,
        reserveSts: this.categoryValue
      }
      this.$store.dispatch(GET_ORDER_LIST_HISTORY, params).then((data) => {
        this.dataList = data.orderInfoList
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
